const authActions = {
  LOGIN_REQUEST: 'LOGIN_REQUEST',
  LOGOUT: 'LOGOUT',
  LOGIN_SUCCESS: 'LOGIN_SUCCESS',
  LOGIN_ERROR: 'LOGIN_ERROR',
  login: data => (
    dispatch => (
      new Promise((resolve, reject) => {
        dispatch({
          type: authActions.LOGIN_REQUEST,
          payload: data,
          resolve,
          reject,
        });
      })
    )
  ),
  logout: () => ({
    type: authActions.LOGOUT,
  }),
};
export default authActions;



// WEBPACK FOOTER //
// ./src/redux/auth/actions.js